import script from "./CardSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./CardSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./CardSkeleton.vue?vue&type=style&index=0&id=2f4d956c&lang=scss"

const __exports__ = script;

export default __exports__